export function isNotificationAllowed(
  schedule,
  date = new Date()
) {
  if (!schedule) {
    return false;
  }

  const days = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday", 
    "saturday",
  ];

  const day = days[date.getDay()];

  const slots =
    schedule[`${day}_available_time`] || [];

  if (slots.length === 0) {
    return false;
  }

  const currentTime =
    date.getHours() * 3600 +
    date.getMinutes() * 60 +
    date.getSeconds();

  return slots.some((slot) => {
    const [startHour, startMinute, startSecond] =
      slot.start_time.split(":").map(Number);

    const [endHour, endMinute, endSecond] =
      slot.end_time.split(":").map(Number);

    const startTime =
      startHour * 3600 +
      startMinute * 60 +
      startSecond;

    const endTime =
      endHour * 3600 +
      endMinute * 60 +
      endSecond;

    return (
      currentTime >= startTime &&
      currentTime <= endTime
    );
  });
}